import { SingleItemResponse, fetchContent } from './'

type Args = {
  codename: string
  lang: string
  preview?: boolean
}
export const getPageByCodename = async <D>({
  codename,
  lang,
  preview,
}: Args): Promise<SingleItemResponse<D>> => {
  const language = lang
  const data = await fetchContent({ path: `/${codename}`, preview, params: { language } })
  return data
}
